/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */
import { Comments, Comment } from '../../data/interfaces';
import {
    FETCH_API_COMMENTS_REQUEST, FETCH_API_COMMENTS_SUCCESS, FETCH_API_COMMENTS_FAILURE,
    POST_COMMENT_REQUEST, POST_COMMENT_SUCCESS, POST_COMMENT_FAILURE,
    DELETE_COMMENT_REQUEST, DELETE_COMMENT_SUCCESS, DELETE_COMMENT_FAILURE, EDIT_COMMENT_FAILURE, EDIT_COMMENT_REQUEST, EDIT_COMMENT_SUCCESS,
} from '../types/comments';

export const fetchApiCommentsRequest = () => {
    return {
        type: FETCH_API_COMMENTS_REQUEST
    }
}

export const fetchApiCommentsSuccess = (comments: Comments) => {
    return {
        type: FETCH_API_COMMENTS_SUCCESS,
        payload: comments
    }
}

export const fetchApiCommentsFailure = (error: string) => {
    return {
        type: FETCH_API_COMMENTS_FAILURE,
        payload: error
    }
}

export const postApiCommentsRequest = () => {
    return {
        type: POST_COMMENT_REQUEST
    }
}

export const postApiCommentsSuccess = (comment: Comment) => {
    return {
        type: POST_COMMENT_SUCCESS,
        payload: comment
    }
}

export const postApiCommentsFailure = (error: string) => {
    return {
        type: POST_COMMENT_FAILURE,
        payload: error
    }
}

export const deleteApiCommentsRequest = () => {
    return {
        type: DELETE_COMMENT_REQUEST
    }
}

export const deleteApiCommentsSuccess = (commentId: string) => {
    return {
        type: DELETE_COMMENT_SUCCESS,
        payload: commentId
    }
}

export const deleteApiCommentsFailure = (error: string) => {
    return {
        type: DELETE_COMMENT_FAILURE,
        payload: error
    }
}

export const editApiCommentsRequest = () => {
    return {
        type: EDIT_COMMENT_REQUEST
    }
}

export const editApiCommentsSuccess = (comment: Comment) => {
    return {
        type: EDIT_COMMENT_SUCCESS,
        payload: comment
    }
}

export const editApiCommentsFailure = (error: string) => {
    return {
        type: EDIT_COMMENT_FAILURE,
        payload: error
    }
}
